import React from 'react'
import rating from '../images/rating.png';
import homebg from '../images/homebg.png';
import homerightImage from '../images/home-right.webp';
import marketing2 from '../images/Hrias-video-thumb.jpg';
import marketing3 from '../images/Hrias-video.mp4';
import { FaStar, FaPlay } from "react-icons/fa";
import Swal from "sweetalert2";

function CaseStudyB2C() {

    const testimonials = [
        {
            img: "https://i.pravatar.cc/120?img=15",
            rating: 5,
            title: "Tripled Customer Messages Through Instagram",
            text: "Hrias helped us automate Instagram replies and follow-ups. Customer messages tripled within weeks — perfect for growing a social-first brand.",
            name: "Emily Harris",
            position: "Store Owner",
            company: "GlowCart Boutique",
        },
        {
            img: "https://i.pravatar.cc/120?img=2",
            rating: 5,
            title: "67% More Orders Through WhatsApp Automations",
            text: "WhatsApp follow-ups from Hrias increased our repeat orders dramatically. It saves us hours every day.",
            name: "Jacob Wilson",
            position: "Founder",
            company: "Snackify Hub",
        },
        {
            img: "https://i.pravatar.cc/120?img=5",
            rating: 5,
            title: "$40,000+ Sales From Facebook Inbox",
            text: "Automating Facebook message replies boosted our conversions massively. Customers get instant answers now.",
            name: "Olivia Brooks",
            position: "Brand Owner",
            company: "UrbanNova Fashion",
        },
        {
            img: "https://i.pravatar.cc/120?img=12",
            rating: 5,
            title: "4X Faster Customer Response Time",
            text: "Instagram + WhatsApp automation made our support so much faster. Customers love the quick replies.",
            name: "Ethan Miller",
            position: "Support Lead",
            company: "FreshBasket Organics",
        },
        {
            img: "https://i.pravatar.cc/120?img=3",
            rating: 5,
            title: "2,000+ Followers Converted to Buyers",
            text: "Hrias automated our DM flows and helped us convert more followers into actual buyers.",
            name: "Hannah Lewis",
            position: "Social Media Manager",
            company: "FitFem Studio",
        },
        {
            img: "https://i.pravatar.cc/120?img=10",
            rating: 5,
            title: "30% Monthly Sales Growth Through WhatsApp",
            text: "The WhatsApp sequences work flawlessly. We see consistent sales increases month after month.",
            name: "Brandon Scott",
            position: "Owner",
            company: "QuickMart Express",
        },
        {
            img: "https://i.pravatar.cc/120?img=7",
            rating: 5,
            title: "Huge Boost in Call-Based Conversions",
            text: "Call reminders and automated follow-ups helped our team close deals far more efficiently.",
            name: "Chloe Turner",
            position: "Sales Lead",
            company: "HomeEase Furnishings",
        },
        {
            img: "https://i.pravatar.cc/120?img=8",
            rating: 5,
            title: "Customer Support Became 5X More Efficient",
            text: "Facebook and Instagram automation reduced our workload and improved customer satisfaction instantly.",
            name: "Nathan Reed",
            position: "Customer Support Manager",
            company: "TravelMate Holidays",
        },
        {
            img: "https://i.pravatar.cc/120?img=9",
            rating: 5,
            title: "Best Tool for Social Selling",
            text: "Our IG and WhatsApp DMs run smoother than ever. Hrias makes daily selling effortless.",
            name: "Ava Mitchell",
            position: "Entrepreneur",
            company: "The Beauty Garden",
        },
        {
            img: "https://i.pravatar.cc/120?img=14",
            rating: 5,
            title: "Instant Replies Boosted Our Conversions",
            text: "Customers respond 10x faster now. Hrias handles all the initial replies perfectly.",
            name: "Logan Wright",
            position: "Owner",
            company: "SmartHome Store",
        },
        {
            img: "https://i.pravatar.cc/120?img=11",
            rating: 5,
            title: "Perfect for Consumer Brands",
            text: "WhatsApp and Instagram automation helped us build real relationships with our customers.",
            name: "Ella Thompson",
            position: "Marketing Lead",
            company: "BloomSkincare Co.",
        },
        {
            img: "https://i.pravatar.cc/120?img=4",
            rating: 5,
            title: "Best Alternative to Expensive Chat Tools",
            text: "Simple, affordable, and powerful. WhatsApp flows alone make Hrias worth it.",
            name: "William Foster",
            position: "Owner",
            company: "SnackUp Supplies",
        },
        {
            img: "https://i.pravatar.cc/120?img=6",
            rating: 5,
            title: "Helps Us Talk to Customers at the Right Time",
            text: "Hrias alerts us instantly when customers re-engage, making calling and follow-ups super easy.",
            name: "Joe Adams",
            position: "Sales Executive",
            company: "UrbanPet Supplies",
        },
        {
            img: "https://i.pravatar.cc/120?img=13",
            rating: 5,
            title: "Simple, Clean & Powerful for Daily Selling",
            text: "All our WhatsApp, Facebook, and Instagram chats stay organized and easy to manage.",
            name: "Michael Carter",
            position: "Operations Manager",
            company: "TechWave Gadgets",
        },
    ];


    const openVideoPopup = () => {
        Swal.fire({
            html: `
          <div style="position: relative;">
            <iframe
              width="50%"
              height="350"
              src=${marketing3} type="video/mp4"
              frameborder="0"
              allow="autoplay; encrypted-media"
              allowfullscreen
              style="border-radius:10px;"
            ></iframe>
          </div>
        `,
            background: "#111",
            width: 750,
            padding: 0,
            showConfirmButton: false,
            showCloseButton: true,
            customClass: {
                popup: "video-popup-style",
                closeButton: "video-popup-close"
            }
        });
    };


    return (
        <><section
            id="home"
            style={{
                backgroundImage: `url(${homebg})`,
            }}
        >
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-md-6 ">
                        <h1 className="display-4 fw-bold">
                            Discover what <span className="highlight-orange">our customers</span> have to say!
                            <img
                                src={rating}
                                alt="Best Software Solution"
                                style={{ height: '65px', marginLeft: '10px', verticalAlign: 'middle' }}
                            />
                        </h1>

                        <p className="lead">
                            Hrias by Peregrinee is a powerful B2C engagement platform that helps you connect with
                            highly interested customers across Facebook, Instagram, and WhatsApp.
                            Read our Hrias by Peregrinee reviews to see why individuals and businesses worldwide love using it.
                        </p>

                        {/* <p className="lead">
      <h1 className="fw-bold "><span className="highlight-orange">Why </span>Partner<span className="highlight-orange"> With</span>  Us?</h1>
      <ul className="mt-3">
        <li>100% Money Back Guarantee if We Can't Deliver Results</li>
        <li>We Build Software Exactly as Per Your Budget</li>
      </ul>
    </p> */}
                        <div className="row mt-4">
                            <div className="col-12 col-md-6 mb-3 mb-md-0">
                                <a href="/contact-us-hrias" className="btn custom-orange-btn w-100 py-3 px-4 fw-bold">Contact Sales</a>
                            </div>
                            {/* <div className="col-12 col-md-6">
      <a href="#contact-us" className="btn custom-orange-btn-outline w-100 py-3 px-4 fw-bold">Book a Free Consultation</a>
    </div> */}
                        </div>

                        {/* <div className="row mt-5">
      {[
        { title: '350+', desc: 'Clients' },
        { title: '8', desc: 'Countries' },
        { title: '15+', desc: 'Industries' }
      ].map((item, idx) => (
        <div className="col-12 col-md-4 mb-4" key={idx}>
          <div className="info-card text-center p-4 h-100">
            <h2 className="fw-bold mb-2" style={{ color: '#ff6600' }}>{item.title}</h2>
            <p className="mb-0 fs-4 fw-bold">{item.desc}</p>
          </div>
        </div>
      ))}
    </div> */}

                    </div>

                    {/* Right column - You can add an image, text, or anything here */}
                    <div className="col-md-6"
                    >
                        <img src={homerightImage} alt="#1 Software Development Service" className="img-fluid" />
                        {/* <div className="lead-form-wrapper">
      <LeadForm />
    </div> */}
                    </div>
                </div>
            </div>
        </section>

            <div className="container py-5">
                <h2 className="text-center mb-5 fw-bold">Wall of Love</h2>

                {/* <section className="container my-5">
                    <div className="row align-items-center">

                        <div className="col-md-6 position-relative text-center">
                            <img
                                src={marketing2}
                                alt="Case Study Thumbnail"
                                className="rounded shadow"
                                style={{ maxWidth: "60%", height: "auto" }}
                            />


                            <div
                                onClick={openVideoPopup}
                                style={{
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    background: "rgba(0,0,0,0.5)",
                                    width: "80px",
                                    height: "80px",
                                    borderRadius: "50%",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    cursor: "pointer",
                                    transition: "0.3s"
                                }}
                                onMouseOver={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.7)")}
                                onMouseOut={(e) => (e.currentTarget.style.background = "rgba(0,0,0,0.5)")}
                            >
                                <FaPlay style={{ fontSize: "32px", color: "#fff" }} />
                            </div>
                        </div>

                        <div className="col-md-6 mt-4 mt-md-0">
                            <p className="fw-bold" style={{ color: "#0d6efd", fontSize: '20px' }}>Case Study</p>

                            <h1 className="fw-bold" style={{ lineHeight: "1.3" }}>
                                <span style={{ color: "#0d6efd" }}>Nervana Co.</span> Generates <span style={{ color: "#0d6efd" }}>$300k</span> in Pipeline and Achieves <span style={{ color: "#0d6efd" }}>89% ROI</span> with <span style={{ color: "#0d6efd" }}>Hrias by Peregrinee</span>
                            </h1>

                            <button
                                onClick={openVideoPopup}
                                className="btn btn-primary mt-4"
                                style={{
                                    backgroundColor: "#134373",
                                    borderRadius: "25px",
                                    border: "none",
                                    padding: "12px 28px",
                                    fontWeight: "600"
                                }}
                                onMouseOver={(e) => (e.target.style.backgroundColor = "#5197dc")}
                                onMouseOut={(e) => (e.target.style.backgroundColor = "#134373")}
                            >
                                Watch Case Study
                            </button>
                        </div>
                    </div>

                    <style>{`
        .video-popup-close {
          color: white !important;
          font-size: 22px !important;
          position: absolute !important;
          top: 10px !important;
          right: 12px !important;
        }
        .video-popup-style {
          border-radius: 12px !important;
        }
      `}</style>
                </section> */}

                <div className="row g-4">
                    {testimonials.map((t, index) => (
                        <div key={index} className="col-md-6">
                            <div className="p-4 shadow rounded bg-white d-flex gap-3">
                                <img
                                    src={t.img}
                                    alt="profile"
                                    className="rounded-circle"
                                    style={{ width: "70px", height: "70px", objectFit: "cover" }}
                                />

                                <div>
                                    <div className="text-warning mb-1">
                                        {[...Array(t.rating)].map((_, i) => (
                                            <FaStar key={i} />
                                        ))}
                                    </div>

                                    <h5 className="fw-semibold">{t.title}</h5>
                                    <p className="text-muted">{t.text}</p>

                                    <p className="fw-bold mb-0">{t.name}</p>
                                    <p className="text-muted mb-0">
                                        {t.position} — {t.company}
                                    </p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </div>


        </>

    )
}

export default CaseStudyB2C